module.exports = __webpack_public_path__ + "img/134.ca141a1e.jpg";